module.exports = __webpack_public_path__ + "d800380cb164d62bcfe61a8ff1e4e0de.jpg";